<template>

  <div id="footer" :style="isbecome?'margin-top:0':''">

    <div id="footer_box">
      <div class="footer_box">
        <div>
          <span>{{$t('base.buy')}}</span>
          <span>
            <router-link :to="{path:'/register'}">{{$t('base.registration')}}</router-link>
          </span>
          <span>
            <router-link :to="{path:'/terms/privacy?type=3'}">{{$t('base.biddingBuyingHelp')}}</router-link>
          </span>
          <span>
            <router-link :to="{path: '/seller/list'}">{{$t('base.stores')}}</router-link>
          </span>
        </div>
        <div>
          <span>{{$t('base.sell')}}</span>
          <span>
            <router-link :to="{path:'/login'}" v-if="islogin==null">{{$t('base.startSelling')}}</router-link>
            <i @click="gotoSell('item')" v-if="islogin!=null">{{$t('base.startSelling')}}</i>
          </span>
          <!-- <span>
            <router-link :to="{path:''}">How to sell</router-link>
          </span> -->
        </div>
        <div>
          <span>{{$t('base.stayConnected')}}</span>
          <span>
            <!-- <router-link :to="{path:''}" class="Facebook">Facebook</router-link> -->
            <a href="https://www.facebook.com/profile.php?id=100083139803296" target="_blank" class="Facebook" rel="CardHobby Facebook">{{$t('base.faceBook')}}</a>
          </span>
          <span>
            <!-- <router-link :to="{path:''}" class="Twitter">Twitter</router-link> -->
            <a href="https://twitter.com/CardHobbyOF" target="_blank" class="Twitter" rel="CardHobby Twitter">{{$t('base.twitter')}}</a>
          </span>
        </div>
        <div>
          <span>{{$t('base.aboutCardHobby')}}</span>
          <span>
            <router-link :to="{path:'/Company/companyinfo'}">{{$t('base.companyInfo')}}</router-link>
          </span>
          <span>
            <router-link :to="{path:'/terms/privacy?type=1'}">{{$t('base.policies')}}</router-link>
          </span>
        </div>
        <div>
          <span>{{$t('base.helpContact')}}</span>
          
          <span>
            <i @click="gotoContact()">{{$t('alert.contactUs')}}</i>
          </span>
          <!-- <span>
            <router-link :to="{path:'/login'}" v-if="islogin==null">Seller Center</router-link>
            <i @click="gotoSell()" v-if="islogin!=null">Seller Center</i>
          </span> -->
          <!-- <span>
            <router-link :to="{path:'/login'}" v-if="islogin==null">{{$t('base.sellerCenter')}}</router-link>
            <i @click="gotoSell()" v-if="islogin!=null">{{$t('base.sellerCenter')}}</i>
          </span> -->
          <span>
            <!-- <span class="all_Contact" @click="allContact('16860')">Contact Card Hobby</span> -->
            <!-- <router-link :to="{path:''}">Contact Card Hobby</router-link> -->
          </span>
          <!-- <change-lang></change-lang> -->
        </div>
        <div class='qrCode'>
          <span>{{$t('base.getApp')}}</span>
          <img src="../../static/images/qrcode.png"/>
          <!-- <span>
            <a :href="qrCode"><img src="../../static/images/20230314-144740.png"/></a>
          </span>
          <span>
            <a :href="qrCode"><img src="../../static/images/20230314-144749.png"/></a>
          </span> -->
        </div>
        <!-- <div class='qrCode'><el-image :src="qrCode" /></div> -->
      </div>

      <div class="color_333 footer_f">Copyright &copy; {{copyYear}} Card Hobby. All Rights Reserved.</div>

    </div>
  </div>
</template>

<script>
import changeLang from '@/components/change-lang'
import { getInfo,GoYunXin} from "@/api/public";
export default {
  name: 'footerNav',
  components: {changeLang},
  data() {
    return {
      islogin: null,
      qrCode:'',
      isbecome:false,
      copyYear:'2022-'+new Date().getFullYear()
    }
  },
  created() {
    this.islogin = getInfo();
    this.qrCode=process.env.VUE_APP_SHARE+'/download'
    this.path = this.$route.path.slice(1).split("/");
    if(this.path[0] == "terms"&&this.path[1] == "becomeseller"){
      this.isbecome=true
    }
  },
  methods: {
    // 云信
    allContact(val) {
      if (this.islogin) {
        GoYunXin(this.islogin, val)
      } else {
        this.$router.push({
          name: 'Login'
        })
      }
    },
    gotoContact(){
      this.$root.$emit("contactUS", true);
    },
    // 跳去卖家端
    gotoSell(e) {
      let that=this
      if (this.islogin != null) {
        let isSell = this.islogin.IsSeller
        if (isSell) {
          let url = process.env.VUE_APP_SELL_URL
          if(e=='item'){
            //url =process.env.VUE_APP_SELL_URL+'/#/commodity/New'
            url = process.env.VUE_APP_SELL_URL
          }
          window.open(url)
        } else {
          this.$message({
            type: 'error',
            duration: 1000,
            message: that.$enumInfo.error['NOSell']
          });
        }
      } else {
        this.$message({
          type: 'error',
          duration: 1000,
          message: that.$enumInfo.error['NOSell']
        });
      }
      //console.log(process.env.VUE_APP_SELL_URL)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#footer {
  border-top: 0.5px solid #e0e0e0;
  padding: 24px 0;
  margin: 35px 0 0;
  color: rgba(51, 51, 51, 0.8);
}
#footer_box{
  width: 1200px;
  margin: 0 auto;
}
.footer_box {
  display: flex;
}
.footer_box div {
  /*width: 18.6%;*/
  width: 20%;
}
.footer_box div.qrCode {
}
.footer_box div.qrCode a{
  
}
.footer_box div.qrCode img{
  width: 55%;
  margin-left: 30px;
}
.footer_box div span {
  display: block;
  margin: 0 0 8px 0;
  font-size: 12px;
}
.footer_box div span:first-child {
  font-size: 14px;
  font-weight: bold;
  margin: 0 0 12px 0;
}
.footer_box div span>i{
  cursor: pointer;
  color: #333;
}
.footer_box div span a:hover,.footer_box div span>i:hover {
  color: #5f6dae;
  text-decoration: underline;
  opacity: 1;
}
.footer_box div span:first-child {
  text-decoration: none;
}
.Facebook {
  background: url(../../static/images/fackbook.svg) no-repeat;
  background-position: 1px 2.5px;
  padding: 0 0 0 16px;
}
.Twitter {
  background: url(../../static/images/icon_Twitter.svg) no-repeat;
  background-position: 1px 2.5px;
  padding: 0 0 0 16px;
}
.color_333 {
  margin: 23px 0 0;
  font-size: 12px;
  color: rgba(51, 51, 51, 0.8);
}
.footer_f{
  margin: 0;
  text-align: center;
}
.footer_box div span .all_Contact{
  font-size: 12px;
  font-weight: normal;
      cursor: pointer;
    color: #333;
}
.footer_box div span .all_Contact:hover{
  color: #5f6dae;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue